import { action } from 'easy-peasy';
import { setAiAssistUsageFilter } from '~/services/localStorage/filters';

import { IActionSetAiAssistUsageReportFilters } from '../types';

const setAiAssistUsageReportFilters: IActionSetAiAssistUsageReportFilters = action(
  (state, payload) => {
    const updatedFilters = { ...state.aiAssistUsage.filters, ...payload };
    // save filters to storage
    setAiAssistUsageFilter(updatedFilters);

    state.aiAssistUsage.filters = updatedFilters;
  },
);

export default setAiAssistUsageReportFilters;
